import $ from "jquery";

window.$ = window.jQuery = $;

let locale = $("html").attr("lang");
if (locale !== "en") {
    require("jquery-validation/dist/localization/messages_" +
        locale +
        ".min.js");
}

require("./slider");
import noUiSlider from "nouislider/distribute/nouislider.min";
window.noUiSlider = require("nouislider");
import wNumb from "wnumb/wNumb.min";
window.wNumb = require("wnumb");
require("slick-carousel");
require("jquery-validation");
require("inputmask");
require("magnific-popup");
require('jquery-lazy');
require("selectric");
require("rateyo");
require("./good");
require("./filters");
require("./goodPage");
require("./cart");
require("./main");
// require("./form");
let additionBtn = document.querySelector('.addition-iframe-btn')
let modalAddition = document.querySelector('.modal-iframe-addition')
let modalAdditionClose = document.querySelector('.close-addition-modal')
if (additionBtn) {
    additionBtn.addEventListener('click', function (e) {
        if (additionBtn) {
            modalAddition.classList.add('active')
        }
    })
}

if (modalAdditionClose) {
    modalAdditionClose.addEventListener('click', function (e) {
        // console.log(e.target)
        if (e.target.classList.contains('close-addition-modal')) {
            modalAddition.classList.remove('active')

        }
    })
}

if (modalAddition) {
    modalAddition.addEventListener('click', function (e) {
        if (modalAddition) {
            modalAddition.classList.remove('active')
        }
    })
}

$(document).ready(function() {
    lazyLoad();
})

function lazyLoad() {
    $("img.lazy").Lazy();
}

function escapeHtml(str) {
    var map = {
        '&': '%26',
        '<': '%3C',
        '>': '%3E',
        '"': '%22',
        '+': '%2B',
        "'": '%27'
    };
    return str.replace(/[&<>"'+]/g, function (m) {
        return map[m];
    });
}

$("#input_search")
    .on("focus", function (event) {
        $('.js_search_data').addClass('is_active');
        if ($(this).val() != "" && $('.js_search_data').find(".search_result").length != 0) {
            $('.js_search_result_overlay').addClass('is_active');
        }
    });

$("#input_search").on('input', function () {
    let query = $(this).val();
    // if(query != "") {
    $.ajax({
        type: "POST",
        dataType: "json",
        url: routes.getTypeahead,
        data: {
            "search": $.trim(query),
        },
        error: function () { },
        success: function (data) {
            console.log(query);
            console.log(data);
            $('.js_search_data').empty().append(data.html);
            if (data.html) {
                $('.js_search_result_overlay').addClass('is_active');
            }
            else {
                $('.js_search_result_overlay').removeClass('is_active');
            }
            if ($.trim(query)) {
                $("#do_search").addClass('is_active');
            } else {
                $("#do_search").removeClass('is_active')
                $('.js_search_result_overlay').removeClass('is_active');
                $("#do_search").removeClass('is_active');
                $('.js_search_data').empty();
            }
        }
    })
});